import React, { useState } from "react";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import DatePicker from "../../datePicker/DatePicker";
import MappedServicesFilter from "../../serviceReletionships/mappedServices/MappedServicesFilter";
import TransactionStatusSelect from "../../transactions/TransactionStatusSelect";
import { TRANSFER_USER } from "../../../../utils/consts";
import { getEndOfDayFromDate, getStartOfDayFromDate, TimestampToDate } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../filter/styledFiter";
import { StyledDatepicker } from "../../../styles/styledDatepicker";

const TransferFilter = ({ filterData, setFilterData, direction }) => {
  const { t } = useTranslation("transferPage");

  const reverseDirection = direction === TRANSFER_USER.RECEIVER
    ? TRANSFER_USER.SENDER
    : TRANSFER_USER.RECEIVER;

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "id": "",
    "note": "",
    [`${reverseDirection}.email`]: "",
    "currency.asset": null,
    "service.name": null,
    "status": null,
    "createdAt[gte]": null,
    "createdAt[lte]": null,
    "updatedAt[gte]": null,
    "updatedAt[lte]": null,
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <StyledFilterGroup>
              <label htmlFor="id">Id</label>
              <DelayInput
                id="id"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                name="id"
                value={filterData["id"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="note">
                {t("filter.note")}
              </label>
              <DelayInput
                id="note"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "note": event.target.value, page: 1 })}
                name="note"
                value={filterData["note"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="email">{t("filter." + reverseDirection)}</label>
              <DelayInput
                id="email"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  [`${reverseDirection}.email`]: event.target.value,
                  page: 1
                })}
                name="email"
                value={filterData[`${reverseDirection}.email`]}
                type="text"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.service")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <MappedServicesFilter
              checkedService={filterData["service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "service.name")}

              checkedCurrency={filterData["currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "currency.asset")}

              withPaymentSystem={false}
            />
            <StyledSelectGroup>
              <TransactionStatusSelect
                checkedStatus={filterData["status"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "status": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="createdAtFrom">
                {t("filter.createdAtFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="createdAtFrom"
                name="createdAtFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createdAt[gte]": getStartOfDayFromDate(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="createdAtTo">
                {t("filter.createdAtTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="createdAtTo"
                name="createdAtTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createdAt[lte]": getEndOfDayFromDate(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[lte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="updatedAtFrom">
                {t("filter.updatedAtFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="updatedAtFrom"
                name="updatedAtFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "updatedAt[gte]": getStartOfDayFromDate(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["updatedAt[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="updatedAtTo">
                {t("filter.updatedAtTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="updatedAtTo"
                name="updatedAtTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "updatedAt[lte]": getEndOfDayFromDate(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["updatedAt[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <>
      <StyledFilterWrapper id="filter">
        <Dropdown
          getPopupContainer={() => document.getElementById("filter")}
          overlay={FilterList}
          trigger={["click"]}
          placement="bottomLeft"
          onVisibleChange={onVisibleChange}
          visible={visible}
          closeOnSelect={false}
        >
          <StyledShowFilterBtn>
            <DefaultButton
              color="success"
            >
              {t("filter.filterBtn")}
            </DefaultButton>
          </StyledShowFilterBtn>
        </Dropdown>
      </StyledFilterWrapper>
    </>
  );
};

export default TransferFilter;